export enum UserRolesEnum {
  admin = 'admin',
  sender = 'sender',
  receiver = 'receiver',
}

export enum UserStatusEnum {
  active = 'active',
  disabled = 'disabled',
  removed = 'removed',
  pending = 'pending',
  invited = 'invited',
}

export enum BankAccountTypeEnum {
  checking = 'checking',
  savings = 'savings',
}

export enum DwollaFundingStatusEnum {
  unverified = 'unverified',
  microdeposits_failed = 'microdeposits_failed',
  microdeposits_added = 'microdeposits_added',
  verified = 'verified',
  removed = 'removed',
  microdeposits_completed = 'microdeposits_completed',
  microdeposits_maxattempts = 'microdeposits_maxattempts',
  funding_source_removed = 'funding_source_removed',
}

export enum DwollaCustomerStatus {
  unverified = 'unverified',
  verified = 'verified',
}

export interface UserInterface {
  id?: number;
  email: string;
  role: UserRolesEnum;
  passwordCreatedAt: number;
  storageFolder: string;
  avatarURL: string;
  status: UserStatusEnum;
  createdAt: number;
  updatedAt: number;
  firstName: string;
  lastName: string;
  phone: string;
  inviteToken?: string;
  usedInvitedToken?: string;
  receiverID?: number;
  routingNumber?: string;
  bankAccountType?: BankAccountTypeEnum;
  accountNumber?: string;
  caseNumber: string;
  courtName: string;
  actionNumber: string;
  lastLogin: number;
  acceptTerms: number;
  acceptTermsAt: number;
  dwollaCustomer?: string;
  dwollaCustomerStatus?: DwollaCustomerStatus;
  dwollaFundSource?: string;
  dwollaFundSourceStatus?: DwollaFundingStatusEnum;
  sender: {
    firstName: string;
    lastName: string;
    email: string;
  };
}
